<div class="uk-invisible@m uk-sticky uk-sticky-fixed"
    uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky"
    style="position: fixed;top:0px;width:1519px;">

    <nav class="uk-navbar-container" uk-navbar>
        <div class="uk-navbar-left ">
            <a href="#" class="uk-navbar-toggle uk-hidden@s" uk-navbar-toggle-icon uk-toggle="target: #sidenav"></a>

            
        

            <a class="uk-navbar-item uk-text-bold uk-logo" href="/">
                <img src="assets/logo50.png" style="width: 100px; height: 60px; padding-left: 30px;">

            </a>
        </div>

        <div class="uk-navbar-right ">
            <ul class="uk-navbar-nav uk-visible@s">
                <li class="uk-active ">
                    <a class="uk-text-small uk-text-capitalize" href="aboutus">Company</a>
                    <div class="uk-navbar-dropdown uk-width-small sub-menu">
                        <ul class="uk-nav uk-navbar-dropdown-nav">
                            <li class="uk-active "><a href="aboutus">About Us</a></li>
                            <li class="uk-nav-divider"></li>
                            <li class="uk-active "><a href="value-page">Our Values</a></li>
                            <li class="uk-nav-divider"></li>
                            <li class="uk-active "><a href="technology">Technology</a></li>
                            <li class="uk-nav-divider"></li>
                            <li class="uk-active "><a href="our_team">Our Team</a></li>
                            <li class="uk-nav-divider"></li>
                            <li class="uk-active "><a href="https://websoullabsblog.000webhostapp.com/">Blog</a></li>
                        </ul>
                    </div>
                </li>

                <li class="uk-active"><a class="uk-text-small uk-text-capitalize " href="service-page"> Services</a>

                    <div class="uk-navbar-dropdown uk-width-medium sub-menu">
                        <ul class=" uk-nav uk-navbar-dropdown-nav">

                            <li class="uk-active">
                             <a  href="web">Web Application Development</a>
                                <div class="uk-navbar-dropdown uk-width-medium" uk-dropdown="pos: right-top">
                                    <ul class="uk-nav uk-navbar-dropdown-nav">
                                <li><a href="business-page"> Customized Business Application</a></li>
                                        <li><a href="php"> PHP Application Development</a></li>
                                        <li><a href="laravel-application-development"> Laravel Application Development</a></li>
                                        <li><a href="cake-php">Cake PHP Application Development</a></li>
                                        <li><a href="pythonapp"> Python Application Development</a></li>
                                        <li><a href="ecommerce-page"> E-Commerce Web Development</a></li>
                                        <li><a href="web-design-and-development"> Web Design And Development</a></li>
                                    </ul>
                                </div>
                            </li>


                            <li class="uk-nav-divider"></li>
                            <li class="uk-active"><a href="mobile-application-development-page"> Mobile Application Development</a>
                                <div class="uk-navbar-dropdown uk-width-medium" uk-dropdown="pos: right-top">
                                    <ul class="uk-nav uk-navbar-dropdown-nav">
                                        <li><a href="iphone"> IPhone Application Development </a></li>
                                        <li><a href="android-app-page"> Android Application Development
                                            </a></li>
                                        <li><a href="phonegap-app-development"> Phone GapApplication Development</a></li>
                                        <li><a href="xamarin"> Xamarin Application Development</a></li>
                                        <li><a href="cross-platform"> Cross platform App Development</a></li>
                                        <li><a href="swift-app">Swift Application Development</a></li>
                                        <li><a href="flutter-page"> Flutter Application Development
                                            </a></li>


                                    </ul>
                                </div>
                            </li>

                            <li class="uk-nav-divider"></li>
                            <li class="uk-active"><a href="#"> Enterprise Application Development</a>
                                <div class="uk-navbar-dropdown uk-width-large" uk-dropdown="pos: right-top">
                                    <ul class="uk-nav uk-navbar-dropdown-nav">
                                        <li><a href="django-page"> Django Development </a></li>
                                        <li><a href="mean_stack">Mean stack</a></li>
                                        <li><a href="odoo-app"> Odoo App Development</a></li>
                                    </ul>
                                </div>
                            </li>
                            <li class="uk-nav-divider"></li>
                            <li class="uk-active"><a href="#">Trending Technologies</a>

                                <div class="uk-navbar-dropdown uk-width-large" uk-dropdown="pos: right-top">
                                    <ul class="uk-nav uk-navbar-dropdown-nav">
                                        <li><a href="ibeacon-page">Ibeacon App Development</a></li>

                                        

                                        <li><a href="wearable-app-development">Wearable App Development</a></li>
                                        <li><a href="interactive-tv-app-development">Interactive TV App Development</a></li>

                                    </ul>
                                </div>
                            </li>
                            <li class="uk-nav-divider"></li>
                            <li class="uk-active"><a href="graphic">Graphic Designing</a></li>
                            <li class="uk-nav-divider"></li>
                            <li class="uk-active"><a href="digital-mart-page"> Digital marketing </a></li>
                        </ul>
                    </div>
                </li>

                <!-- <li class="uk-active"><a class="uk-text-small uk-text-capitalize" href="portfolio"> Portfolio</a></li> -->
                <li class="uk-active"><a class="uk-text-small uk-text-capitalize" href="career">Careers</a></li>
                <li class="uk-active"><a class="uk-text-small uk-text-capitalize" href="contactus"> Contact</a></li>

            </ul>
        </div>
    </nav>

    <div id="sidenav" uk-offcanvas="overlay: true" class="mobile-menu">
        <div class="uk-offcanvas-bar">

            <ul class="uk-nav  uk-nav-parent-icon uk-nav-default" data-uk-nav>
                <li class="uk-parent uk-active">
                    <a class="uk-text-small uk-text-capitalize" href="aboutus">Company</a>

                    <ul class="uk-nav-sub ">
                        <li class="uk-active" style="padding-bottom: 5px;"><a href="aboutus">About Us</a></li>
                        <li class="uk-active" style="padding-bottom: 5px;"><a href="value-page">Our Values</a></li>
                        <li class="uk-active" style="padding-bottom: 5px;"><a href="technology">Technology</a></li>
                        <li class="uk-active" style="padding-bottom: 5px;"><a href="our_team">Our Team</a></li>
                        <li class="uk-active" ><a href="https://websoullabsblog.000webhostapp.com/">Blog</a></li>
                    </ul>

                </li>

                <li class="uk-parent uk-active">
                    <a class="uk-text-small uk-text-capitalize " href="service-page">Services</a>

                    <ul class="uk-nav-sub">

                        <li class="uk-parent uk-active">
                            <a href="web" style="padding-bottom: 5px;">Web Application Development</a>
                            <ul class="uk-nav-sub">
                                <li><a href="business-page" style="padding-bottom: 5px;">Customized Business Application</a></li>
                                <li><a href="php" style="padding-bottom: 5px;">PHP Application <br>Development</a></li>
                                <li><a href="laravel-application-development" style="padding-bottom: 5px;">Laravel Application Development</a></li>
                                <li><a href="cake-php" style="padding-bottom: 5px;">Cake PHP Application Development</a></li>
                                <li><a href="pythonapp" style="padding-bottom: 5px;">Python Application Development</a></li>
                                <li><a href="ecommerce-page" style="padding-bottom: 5px;">E-Commerce Web Development</a></li>
                                <li><a href="web-design-and-development" style="padding-bottom: 5px;">Web Design And Development</a></li>
                            </ul>
                        </li>

                        <li class="uk-parent uk-active">
                            <a href="mobile-application-development-page" style="padding-bottom: 5px;"> Mobile Application Development</a>
                            <ul class="uk-nav-sub">
                                <li><a href="iphone" style="padding-bottom: 5px;"> IPhone Application Development</a></li>
                                <li><a href="android-app-page" style="padding-bottom: 5px;"> Android Application Development</a></li>
                                <li><a href="phonegap-app-development" style="padding-bottom: 5px;"> PhoneGap Application Development</a></li>
                                <li><a href="xamarin" style="padding-bottom: 5px;"> Xamarin Application Development</a></li>
                                <li><a href="cross-platform" style="padding-bottom: 5px;"> Cross platform App Development</a></li>
                                <li><a href="swift-app" style="padding-bottom: 5px;">Swift Application Development</a></li>
                                <li><a href="flutter-page" style="padding-bottom: 5px;"> Flutter Application Development</a></li>
                            </ul>
                        </li>

                        <li class="uk-parent uk-active">
                            <a href="#" style="padding-bottom: 5px;">Enterprise Application Development</a>
                            <ul class="uk-nav-sub">
                                <li><a href="django-page" style="padding-bottom: 5px;"> Django Development </a></li>
                                <li><a href="mean_stack" style="padding-bottom: 5px;"> Mean Stack Development</a></li>
                                <li><a href="odoo-app" style="padding-bottom: 5px;"> Odoo App Development</a></li>
                            </ul>
                        </li>

                        <li class="uk-parent uk-active">
                            <a href="#" style="padding-bottom: 5px;">Trending Technologies</a>
                            <ul class="uk-nav-sub">
                                <li><a href="ibeacon-page" style="padding-bottom: 5px;">Ibeacon App Development</a></li>
                                <li><a href="wearable-app-development" style="padding-bottom: 5px;">Wearable App Development</a></li>
                                <li><a href="interactive-tv-app-development" style="padding-bottom: 5px;">Interactive TV App Development</a></li>
                            </ul>
                        </li>
                        <li class="uk-active"><a href="graphic" style="padding-bottom: 5px;">Graphic Designing</a></li>
                        <li class="uk-active"><a href="digital-mart-page" style="padding-bottom: 5px;"> Digital marketing </a></li>
                    </ul>
                </li>
                <!-- <li class="uk-active"><a class="uk-text-small uk-text-capitalize" style="padding-bottom: 5px;" href="portfolio"> Portfolio</a></li> -->
                <li class="uk-active"><a class="uk-text-small uk-text-capitalize" style="padding-bottom: 5px;" href="career">Careers</a></li>
                <li class="uk-active"><a class="uk-text-small uk-text-capitalize" style="padding-bottom: 5px;" href="contactus"> Contact</a></li>
            </ul>
        </div>
    </div>
</div>

